import { readCustomerMemory, saveCustomerMemory } from '../customerMemory';
import { BnplLimitsOfferMemory } from './types';

const BNPL_LIMITS_OFFER_MEMORY_KEY = '__jarabot_bnpl_limits_offer_memory';

export const createEmptyBnplLimitsOfferMemory = (): BnplLimitsOfferMemory => ({
	lastSentAt: null,
});

export function readBnplLimitsOfferMemory(customerId: string): BnplLimitsOfferMemory {
	const stored = readCustomerMemory(BNPL_LIMITS_OFFER_MEMORY_KEY, customerId);

	return {
		lastSentAt: typeof stored?.lastSentAt === 'string' ? stored.lastSentAt : null,
	};
}

export function saveBnplLimitsOfferContact(customerId: string, now: Date): BnplLimitsOfferMemory {
	const saved: BnplLimitsOfferMemory = { lastSentAt: now.toISOString() };

	saveCustomerMemory(BNPL_LIMITS_OFFER_MEMORY_KEY, customerId, saved);

	return saved;
}
